import { h, Fragment } from "preact";
import { useContext, } from "preact/hooks";
import {

    Typography,
    Box,
    Button,
    Stack

} from "@mui/material";
import CardTemplate from "../Common/CardTemplate";
import ButtonWithTooltipAndBadge from "../Common/ButtonWithTooltipAndBadge";
import NoDeal from "../DashboardAmbassador/NoDeal";
import DealCard from "../Common/DealCard";
import AddIcon from '@mui/icons-material/Add';

import { AppContext } from "../../AppContext";

export default function SellerDealsCard({ ctx }) {
    const app = useContext(AppContext);
    return (
        <CardTemplate
            fullHeight={true}
            title="Vos dossiers de vente en tant que vendeur"
            buttons={<ButtonWithTooltipAndBadge
                tooltip="Nouveau dossier de vente"
                icon={<AddIcon />}
                onclick_cb={() => {
                    ctx.user_undone.length == 0 ? app.refPopUp.current.handleChangeState(
                        {
                            opened: true,
                            type: "017",

                        }) : app.refPopUp.current.handleChangeState(
                            {
                                opened: true,
                                type: "005",

                            })
                }}
                badge={false} />
            }

            content={<Stack spacing={1}>
                {ctx && ctx.deals && ctx.deals.length === 0 && (
                    <Typography variant="body1">Vous n'avez pas encore de dossier de vente enregistré</Typography>
                )}

                {ctx &&
                    ctx.deals &&
                    ctx.deals.map((dl, idx) => {
                        return (

                            <DealCard
                                dl={dl}
                                idx={idx}
                                mode="V"
                                app={app}
                                ctx={ctx}
                            />

                        );
                    })}

                {ctx && ctx.deals && ctx.deals.length === 0 && (
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        flexDirection="column"
                        p={1}
                        m={1}

                    >
                        <Box p={1}>
                            <Typography variant="h5">Vous n'avez pas encore de dossier de vente</Typography>
                        </Box>
                        <Box p={1}>

                            <Button
                                onClick={() => {
                                    ctx.user_undone.length == 0 ? app.refPopUp.current.handleChangeState(
                                        { opened: true, type: "017" }
                                    ) : app.refPopUp.current.handleChangeState(
                                        { opened: true, type: "005" }
                                    )
                                }
                                }
                            >
                                Je commence mon premier dossier de vente
                            </Button>

                        </Box>
                        <Box p={1}>
                            <NoDeal l={ctx.user_undone.length} c={app.refPopUp.current} mode={"V"} />
                        </Box>
                    </Box>
                )}
            </Stack>
            }
        />)

}